'use strict';

module.exports = {
  BRAINTREE_API_VERSION_HEADER: '2017-04-03'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web-drop-in/node_modules/braintree-web/client/constants.js
// module id = Mhgx
// module chunks = 3